// @module SA.ShopperApproved.ShopperApprovedModulePLP
define('SA.ShopperApproved.ShopperApprovedModulePLP.View',	[
	'sa_shopperapproved_shopperapprovedmodule_plp.tpl',	'Backbone'
], function (
	sa_shopperapproved_shopperapprovedmodule_plp_tpl, Backbone
) {
    'use strict';

	// @class SA.ShopperApproved.ShopperApprovedModulePLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: sa_shopperapproved_shopperapprovedmodule_plp_tpl

	,	initialize: function(options) {
            this.model = options.model.model;
        }
    ,   getContext: function() {
            let itemSKU = this.model.attributes.itemid;
                //itemSKU = itemSKU.replace(/[^\w\s]/gi, '');
                itemSKU = itemSKU.replace(/\s+/g, '_'); // add underscore to the brand name
                itemSKU = itemSKU.split('_'); // split the brand name to the actual sku
                itemSKU = itemSKU[itemSKU.length-1]; // get the last array index 
            return {
                // @property {String} label
                itemsku: itemSKU
            };
        }
	});
});
